// extracted by mini-css-extract-plugin
export default {"container":"TwoContent_container__iYQHr","Main":"TwoContent_Main__YbihN","Block":"TwoContent_Block__b9lKG"};